
/// Accordain sscript
document.addEventListener("DOMContentLoaded", function() {
    var triggers = document.querySelectorAll(".accor-number, .accor-heading");

    triggers.forEach(function(trigger) {
        trigger.addEventListener("click", function() {
            var content = this.closest(".accor-title").querySelector(".accor-content");
            
            // Hide all other .accor-content elements
            document.querySelectorAll(".accor-content").forEach(function(el) {
                if (el !== content) {
                    el.style.display = "none";
                }
            });

            // Toggle the display of the clicked section's content
            if (content.style.display === "block") {
                content.style.display = "none";
            } else {
                content.style.display = "block";
            }
        });
    });
});

jQuery(document).ready(function ($) {
    $(".icon-hamburger").click(function () {
        $("body").toggleClass("menu-open");
    });
 $(".icon-close").click(function () {
        $("body").removeClass("menu-open");
    });
});

document.addEventListener("scroll", function () {
    const banner = document.querySelector(".home-banner");
    if (window.scrollY > 100) { // Adjust the scroll threshold as needed
        banner.classList.add("scrolled");
    } else {
        banner.classList.remove("scrolled");
    }
});
function checkZoomLevel() {
    let zoomLevel = Math.round(window.devicePixelRatio * 100);
    document.body.classList.remove("zoom-90", "zoom-80", "zoom-75", "zoom-67", "zoom-50");

    if (zoomLevel === 90) {
        document.body.classList.add("zoom-90");
    } else if (zoomLevel === 80) {
        document.body.classList.add("zoom-80");
    } else if (zoomLevel === 75) {
        document.body.classList.add("zoom-75");
    } else if (zoomLevel === 67) {
        document.body.classList.add("zoom-67");
    } else if (zoomLevel === 50) {
        document.body.classList.add("zoom-50");
    }
}

window.addEventListener("resize", checkZoomLevel);
window.addEventListener("load", checkZoomLevel);


$(document).ready(function () {
    function updateSliderClass() {
        if ($('.slider-button--prev').is(':disabled') || $('.slider-button--next').is(':disabled')) {
            $('.slider-buttons').addClass('has-disabled-button'); // Add class
        } else {
            $('.slider-buttons').removeClass('has-disabled-button'); // Remove class
        }
    }

    // Run initially
    updateSliderClass();

    // Observe changes to the disabled attribute
    const observer = new MutationObserver(updateSliderClass);
    
    $('.slider-button').each(function () {
        observer.observe(this, { attributes: true, attributeFilter: ['disabled'] });
    });
});












